/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions*/
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Layout, Text } from 'components';
import { GridColumnTitle } from "@fitinsur/components";
import {
  ButtonContainer,
  ContentAlert,
  ContentTextarea,
  DialogCancel,
  DialogConfirm,
  DialogRejected,
  DialogSelect,
  NewEnquiryButton,
  ContainerProducts,
  ItemProduct,
  TitleProducts,
  TableHead,
  TableRow,
  TableBody,
  Table,
  TableColumn,
  TableHeader,
  CustomField,
  TableColumnActions,
} from './styles';
import { useHistory, useLocation } from 'react-router-dom';
import Colors from 'constants/Colors';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { Content } from './styles_home';
import { Field, Form, Form as Formikform, Formik } from 'formik';
import {
  Section,
  Loader
} from '@fitinsur/components';
import * as Yup from 'yup';
import { CacheManager, FitinsurAPI, MessageCenter } from 'utils';
import ListHeader from './listHeader';
import ListDetail from './listDetail';
import DialogComponent from 'components/Dialog';
import Access from 'constants/Access';
import HasPermission from 'components/HasPermission/index';
import Badge from 'components/Badge'
import Icon from "components/Icon";
import { NotesModal } from '@fitinsur/components';
import {
  LoaderContext,
} from '@fitinsur/contexts';
import { useGetQuery } from '@fitinsur/services/QuestionnairesService';
import { ResponsiveTable, Label } from '@fitinsur/components/';
import ListEnquiryButtons from 'components/ListEnquiryButtons';

export default function ListPage2({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);

  const cache = new CacheManager();
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const location = useLocation();
  const lostReasonsRef = useRef();
  const [onMouseArrow, setOnMouseArrow] = useState('');
  const [sortBy, setSortBy] = useState(
    {
      key: null,
      direction: null,
    }
  );
  const [hasPermissionCreateFramework, setHasPermissionCreateFramework] = useState(false);
  const [listData, setListData] = useState([]);
  const [typeDialog, setTypeDialog] = useState(null);
  const [userComments, setUserComments] = useState("");
  const [lostDeal, setLostDeal] = useState({ formated: [], array: [] });
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });
  const [headerStatus, setHeaderStatus] = useState([]);
  const [headerBroker, setHeaderBroker] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [message, setMessage] = useState([null]);
  const [notesModal, setNotesModal] = useState(false);
  const [idOperationSelected, setIdOperationSelected] = useState(null);
  const [isMediationFinished, setIsMediationFinished] = useState(false);

  const [paginationControls, setPaginationControls] = useState({
    "currentPage": 1,
    "numberMaxRecords": null,
    "total": null,
    "totalPages": null,
    "numberRecords": null
  })
  const [products, setProducts] = useState(
    [
      {
        label: "NO PRODUCTS",
        value: ""
      }
    ]
  );

  const [showFilter, setShowFilter] = useState(false);

  const {
    request: useGetQueryRequest,
  } = useGetQuery();

  useEffect(() => {
    if (!notesModal) setIdOperationSelected(null);
  }, [notesModal])

  const goToQuotePage = () => {
    history.push('quote');
  };

  const goToLoginPage = () => {
    history.push('login');
  };

  const requestLostDealList = () => {

    fitinsur.requestLostDealList()
      .then((response) => {
        return response.json();
      })
      .then((data) => {

        if (data.ret_code !== 200) {
          return;
        }
        if (data.ret_value) {
          const lista = [];
          for (let index = 0; index < data.ret_value.length; index++) {
            lista.push({ label: data.ret_value[index].ANSWER_OPTION_DESCRIPTION, value: data.ret_value[index].ID_ANSWER_OPTION })

          }
          setLostDeal({ formated: lista, array: data.ret_value });

        }
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data: \n" + error);
        console.error('fitGetLostReason - Error:', error);
        setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
      });
  }


  async function requestProductsList() {
    const response = await fitinsur
      .requestAccess("", "CREATE", Access.CREATE_FRAMEWORK, null, null, authContext.token)
      .then((response) => response.json())

    const hasPermission = response && response.ret_code === 200;

    fitinsur.requestProductsList()
      .then(x => x.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        const options = response.ret_value
          .map(product => ({
            label: product.ID_PRODUCT === 48 ? 'RC Profissional' : product.PRODUCT_NAME,
            value: product.ID_PRODUCT
          }))
          .filter(product => {
            if (product.value === 16 && !hasPermission) {
              return;
            } else {
              return product;
            }
          })
        setProducts(options);
      })
      .catch(error => console.log(error));

    setHasPermissionCreateFramework(hasPermission);
  }


  const requestBrokerList = async () => {
    const { data } = await useGetQueryRequest({
      id: 'fitQueryPersonClient',
      params: {
        id: "fitQueryPersonClient",
        queryTail: true,
        personName: ''
      }
    });

    try {
      if (data.ret_code !== 200) return;

      const persons = data.ret_value.map(person => ({
        ...person,
        label: person.personName,
        value: person.id
      }));

      setBrokerList(persons);
    } catch (err) {
      console.log("err fitQueryPersonClient", err)
    };
  };

  const requestStatusList = () => {
    fitinsur.requestStatusHeader()
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        const mappedOpt = res.ret_value.map(x => {
          return { label: x.description, value: x.id }
        })

        setHeaderStatus(mappedOpt);
      })
  }

  const requestBrokerHeaderList = () => {
    fitinsur.requestBrokerHeader()
      .then(data => data.json())
      .then(response => {
        if (response.ret_code === 200) {
          const mappedOpt = response.ret_value.map(data => ({ label: data.nmPersonBroker, value: data.ID_PERSON || data.idPersonUser }));
          setHeaderBroker(mappedOpt);
        } else {
          mc.error("An error happened, please try again.");
        }
      })
  }

  const selectBroker = (a) => {
    setTypeDialog('mc.errorBroker');
    setDialog({
      visible: true,
      title: 'Attention',
      icon: 'exclamation',
      args: a
    });
  }

  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const newEnquiry = () => {
    setTypeDialog('selectProduct');
    setDialog({
      visible: true,
      title: 'Selecione o produto',
      icon: 'exclamation',
      args: null
    })
  }

  const createModalBody = async (context, argS) => {
    fitinsur.setAuthToken(authContext.token);
    await requestLostDealList();
    setTypeDialog(context === "lost" ? 'lostReason' : 'ApproveAnalysis');
    setDialog({
      visible: true,
      title: context === "lost" ? 'LOST DEAL' : 'STATUS ANALYSIS',
      icon: context === "lost" ? 'times-circle' : 'exclamation',
      args: argS
    })
  }

  const HandleLostSubmit = (selectedID, array, argsContext) => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.updateQuoteEdit(argsContext.idOperation, selectedID.reasons).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      setDialog({ visible: false, title: null, icon: null, args: null });
      lostReasonsRef.current.setFieldValue('reasons', '');
      handleFilter();
    })
  }

  const HandleApproveButton = (argsContext) => {
    handleFilter();
    fitinsur.requestQuoteApprove({ idOperation: argsContext.idOperation, txtAnswerOption: userComments }).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      setDialog({ visible: false, title: null, icon: null, args: null });
      handleFilter();
      setUserComments('');
    })
  }

  const HandleRejectButton = (argsContext) => {
    fitinsur.requestQuoteReject({ idOperation: argsContext.idOperation, txtAnswerOption: userComments }).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      setDialog({ visible: false, title: null, icon: null, args: null });
      handleListState();
      setUserComments('');
    })

  }

  const checkOperationRoute = (idOperation, idProduct, idDomainStatusDoc) => {
    fitinsur.setAuthToken(authContext.token);
    updateIsLoadingStatus(true);

    fitinsur.requestPolicyNavigation(idOperation).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }

      let route = res.ret_value.route || `/edit-enquiry/${idProduct}/${idOperation}`;
      if (route) {
        updateIsLoadingStatus(false);
        history.push({ pathname: route, state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { status: idDomainStatusDoc, idProduct: idProduct } })
      } else {
        mc.error('NAVIGATION NOT DEFINED');
        updateIsLoadingStatus(false);
      }
    }).catch(() => updateIsLoadingStatus(false));
  }

  const handleNewEnquiry = () => {
    return <HasPermission permission={permissions.CREATE_ENQUIRY}>
      {/* < NewEnquiryButton style={{ minHeight: showFilter ? '450px' : '' }}> */}
      <Text primary
        type="button"
        id="btnSubmit"
        style={{ cursor: 'pointer' }}
        onClick={newEnquiry}>
        NOVA COTAÇÃO
      </Text>
      {/* </NewEnquiryButton> */}
    </HasPermission>
      ;
  }

  const handleListState = (page = 1, filterQueryString = '?') => {
    updateIsLoadingStatus(true);
    fitinsur.setAuthToken(authContext.token);

    const url = `${filterQueryString}&idBrokerQuestion=688&requestPage=${page}`

    fitinsur.requestListAction(url)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          updateIsLoadingStatus(false);
          return;
        }
        if (data.ret_code !== 200) {
          setListData([]);
          updateIsLoadingStatus(false);
          return;
        }

        if (data.ret_value?.length > 0) {
          setListData([]);
          const lista = [];

          for (let index = 0; index < data.ret_value.length; index++) {
            let element = data.ret_value[index];
            if (Array.isArray(element.listBrokers)) {
              element.listBrokers.forEach(element => {
                element.label = element.nmPersonBroker;
                element.value = element.idPersonUser
              });
              element.listBrokers.sort((first, next) => String(first.label).localeCompare(String(next.label)))
            } else {
              element.listBrokers = [{ value: '', label: element.nmObligor }]
            }
            lista.push(element);
          }

          lista.map(item => {
            item.sla = Badge({ sla: { today: new Date(), operationDate: item.operationDate } })

            const date = new Date(item.operationDate).toLocaleDateString('pt-BR').toString()
            item.operationDate = date

            return item;
          })
          
          const pagination = { ...data.pagination_control };

          if (+pagination.currentPage === 1) {
            setListData(lista)
          } else {
            setListData([...listData, ...lista]);
          }

          pagination.currentPage = parseInt(pagination.currentPage);
          setPaginationControls(pagination);
          setTimeout(() => updateIsLoadingStatus(false), 1000);
        } else {
          setListData([]);
          updateIsLoadingStatus(false);
        }
      })
      .catch((error) => {
        console.error('handleListState - Error:', error);
        updateIsLoadingStatus(false);
      });
  }

  const jsonToQueryString = (json) => {
    const keys = Object.keys(json).filter(key => json[key]);

    const queryUrl = keys
      .map((key, index) => {
        const sufix = index + 1 === keys.length
          ? ''
          : '&'

        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) + sufix;
      }
      ).join('');
    return queryUrl
  }

  const handleFilter = (filters = {}) => {
    let operationDateRange = {};

    if (filters?.operationDate?.from && filters?.operationDate?.to) {
      operationDateRange = {
        operationDateFrom: new Date(filters.operationDate.from),
        operationDateTo: new Date(filters.operationDate.to),
      }
    }
    const { operationDate, ...rest } = filters;

    const queryString = jsonToQueryString({
      ...rest,
      ...operationDateRange,
    })

    const filterQueryString = `?${queryString}`;

    fitinsur.setAuthToken(authContext.token);
    handleListState(1, filterQueryString)

    if (queryString) {
      localStorage.setItem('enquiries_filter_hdiglobal', filterQueryString)
    } else {
      localStorage.removeItem('enquiries_filter_hdiglobal')
    }

    history.push(`enquiries${filterQueryString}`)
  }

  const handleSetFilterFromParams = () => {
    if (location.search) {
      const query = new URLSearchParams(location.search);

      if (query.get('nmClient')) {
        filterFormik.current.setFieldValue('nmClient', query.get('nmClient'))
      }

      if (query.get('nmObligor')) {
        filterFormik.current.setFieldValue('nmObligor', query.get('nmObligor'))
      }

      if (query.get('idOperation')) {
        filterFormik.current.setFieldValue('idOperation', Number(query.get('idOperation')))
      }

      if (query.get('status')) {
        filterFormik.current.setFieldValue('status', Number(query.get('status')))
      }

      if (query.get('productName')) {
        filterFormik.current.setFieldValue('productName', Number(query.get('productName')))
      }


      if (query.get('dateRangeFrom') || query.get('dateRangeTo')) {
        filterFormik.current.setFieldValue('dateRangeTo', new Date(query.get('dateRangeTo')));
        filterFormik.current.setFieldValue('dateRangeFrom', new Date(query.get('dateRangeFrom')))
        filterFormik.current.setFieldValue('operationDate', {
          from: new Date(query.get('dateRangeFrom')),
          to: new Date(query.get('dateRangeTo')),
        })
      }

      if (query.get('userName')) {
        filterFormik.current.setFieldValue('userName', query.get('userName'))
      }
    }
  }

  const region = authContext.region === 'en-GB' ? 'en' : 'en';

  const handleGetPreviusFilter = () => {
    const filterQueryString = localStorage.getItem('enquiries_filter_hdiglobal');

    if (filterQueryString) {
      history.push(`enquiries${filterQueryString}`)
      handleListState(1, filterQueryString)

    } else {
      handleListState()
    }
  }

  const handleExportQuotes = async (page = 1, filterQueryString = '?') => {
    let exportList = sessionStorage.getItem('texel-export-list-report');
    let list = [];

    if (exportList) list = JSON.parse(sessionStorage.getItem('texel-export-list-report'))
    let verify = list.length > 0 ? list.filter(item => item.nameList == 'Relatório de Cotações') : false;

    if (!verify || verify.length==0) {
      updateIsLoadingStatus(true);
      setTimeout(() => updateIsLoadingStatus(false), 2000);
      const url = `${filterQueryString}&brokerColumn=true&idBrokerQuestion=688&requestPage=${page}`;
      fitinsur.setAuthToken(authContext.token);
      const document = await fitinsur.exportQuotes(url).then(x => x.json());
      updateIsLoadingStatus(true);
      setTimeout(() => updateIsLoadingStatus(false), 2000);
      if (document.idDocument) {
        list.push({ idDocument: document.idDocument, processing: true, nameList: 'Relatório de Cotações' });
        sessionStorage.setItem('texel-export-list-report', JSON.stringify(list));
      }
    } else {
      mc.error("Por favor, aguarde o relatório ser baixado.");
    }
  }

  useEffect(() => {
    updateIsLoadingStatus(false);
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      goToLoginPage();
    } else {
      fitinsur.setAuthToken(authContext.token);

      if (location.search) {
        handleSetFilterFromParams()
        handleListState(1, location.search);
      } else {
        handleGetPreviusFilter();

      }
      requestBrokerList();
      requestProductsList();
      requestStatusList();
      requestBrokerHeaderList();
    }

    setLostDeal({ formated: [], array: [] });
    cache.getMessage("NO_ITEMS_LIST", region, "355", authContext.token).then(msg => setMessage(msg)).catch(err => console.log("error", err));
  }, []);

  let filterFormik = useRef({});

  const columnsFilter = [
    { title: "NÚMERO", key: 'orderIdOperation', fieldKey: 'idOperation', type: 'text', showFilter: true, arrowOrder: false, width: 10, minWidth: 10, maxWidth: 10 },
    { title: "DATA DE CRIAÇÃO", key: 'orderOperationDate', fieldKey: 'operationDate', type: 'calendar', showFilter: true, arrowOrder: false, width: 10, minWidth: 10, maxWidth: 10 },
    { title: "USUÁRIO", key: 'orderUser', fieldKey: 'userName', type: 'text', arrowOrder: false, showFilter: true, width: 10, minWidth: 10, maxWidth: 10 },
    { title: "CORRETORA", key: 'orderBroker', fieldKey: 'nmBroker', type: 'list', arrowOrder: false, showFilter: true, options: brokerList, width: 10, minWidth: 10, maxWidth: 10 },
    { title: "PRODUTO", key: 'orderProductName', fieldKey: 'productName', type: 'list', showFilter: true, arrowOrder: false, options: products, width: 10, minWidth: 10, maxWidth: 10 },
    { title: "PROPONENTE", key: 'orderProponent', fieldKey: 'nmClient', type: 'text', showFilter: true, arrowOrder: false, width: 10, minWidth: 10, maxWidth: 10 },
    { title: "SITUAÇÃO", key: 'orderStatus', fieldKey: 'status', type: 'list', showFilter: true, arrowOrder: false, options: headerStatus, width: 10, minWidth: 10, maxWidth: 10 },
    { title: "SLA", key: 'orderSla', fieldKey: 'sla', type: 'calendar', arrowOrder: false, showFilter: false, width: 10, minWidth: 10, maxWidth: 10 },
    { title: "AÇÕES", key: 'action', fieldKey: '', type: '', arrowOrder: false, showFilter: false, width: 10, minWidth: 10, maxWidth: 10 },
  ]

  const handleColorLabel = (item) => {
    if (item.isRejected) return Colors.GRAY[3];
    else if (item.isApproved) return Colors.GRAY[0];
    else if (item.idDomainStatusOper === 4 && item?.additionalInformation) return Colors.RED;
    else if (item.mediationFinished) return Colors.SECONDARY;
    else return null;
  }

  const columns = [
    {
      title: "NÚMERO",
      key: "idOperation",
      sortKey: 'orderIdOperation',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "DATA DE CRIAÇÃO",
      key: "operationDate",
      sortKey: 'orderOperationDate',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "USUÁRIO",
      key: "userName",
      sortKey: 'orderUser',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "CORRETORA",
      key: "nmBroker",
      sortKey: "orderBroker",
      minWidth: 16,
      maxWidth: 16,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "PRODUTO",
      key: "productName",
      sortKey: 'orderProductName',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "PROPONENTE",
      key: "nmClient",
      sortKey: 'orderProponent',
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "SITUAÇÃO",
      key: "status",
      minWidth: 15,
      maxWidth: 15,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        return <>
          <Label wordWrap fontSize={13} color={handleColorLabel(listItem)}>
            {((listItem.idDomainStatusOper === 4 && listItem?.additionalInformation) || listItem.mediationFinished) &&
              <Icon
                name={'info'}
                title="Informações Adicionais"
                style={{ margin: 0, marginBottom: -5 }}
                className="mr-1"
                onClick={() => {
                  setIdOperationSelected(listItem.idOperation)
                  setNotesModal(true)
                  setIsMediationFinished(listItem.mediationFinished)
                }}
              />
            }
            {listItem['status'] || '-'}
          </Label>
        </>
      },
    },
    {
      title: "SLA",
      key: "sla",
      sortKey: 'orderSla',
      minWidth: 9,
      maxWidth: 9,
      component: (listItem) => listItem.sla,
      color: (item) => handleColorLabel(item)
    },
    {
      title: "AÇÕES",
      key: "action",
      minWidth: 8,
      maxWidth: 8,
      paddingRight: 5,
      component: (listItem) => <ListEnquiryButtons
        editRoute={checkOperationRoute}
        listItem={listItem}
        idOperation={listItem.idOperation}
        permissions={props.permissions || {}}
        authContextToken={authContext?.token}
        toDocument={() => history.push(`/broking/document-management/${listItem.idOperation}`)}
      />
    },
  ];

  const enumProductIcons = {
    34: "do",
    48: "rcp"
  }

  return (
    <>
      <Layout title={'Cotações'}>
        <NotesModal
          title={'Informações Adicionais'}
          textButtonConfirm={'Confirmar'}
          textButtonCancel={'Cancelar'}
          show={notesModal}
          setModalShow={setNotesModal}
          idOperation={idOperationSelected}
          idQuestion={1198}
          isMediationCompleted={isMediationFinished}
          textMediation='Cotação disponível, acesse a pasta de Documentos para realizar o download.'
          viewMode={true}
        />
        <p style={{ margin: '14px auto' }}>Nova Cotação:</p>
        <ContainerProducts>
          {permissions.CREATE_ENQUIRY && products.map(item => (
            <ItemProduct onClick={() => history.push(`create-enquiry/${item.value}`)}>
              <Icon name={enumProductIcons[item?.value]} />
              <TitleProducts> {item.label}</TitleProducts>
            </ItemProduct>
          ))}
        </ContainerProducts>
        <Content style={{ marginBottom: '5%', boxShadow: '0px 8px 3px -4px lightgrey' }}>
          <ListHeader
            formikRef={ref => filterFormik.current = ref?.current}
            ListHeader
            columns={columnsFilter}
            status={headerStatus}
            broker={headerBroker}
            exportList={() => handleExportQuotes(1, location.search || undefined)}
            updateFilter={(filters) => {
              handleFilter(filters)
            }}
            onShowFilter={(showFilter) => setShowFilter(showFilter)}
          />
          <>
            <Formik
              initialValues={{}}
              validationSchema={Yup.object({})}
              onSubmit={values => {
                goToQuotePage();
              }}
            >
              <>
                <ResponsiveTable formikRef={filterFormik?.current} columns={columns} data={listData} />
                {!listData.length && <ButtonContainer style={{ minHeight: '450px' }}>
                  <Text style={{ fontWeight: 'bold', color: Colors.GRAY[1], margin: 'auto', cursor: 'pointer', marginTop: '10px' }} onClick={() => { }}>{message || ''}</Text>
                </ButtonContainer>}
              </>
            </Formik>
          </>
        </Content>
        {paginationControls.currentPage < paginationControls.totalPages ? (
          <ButtonContainer>
            <Text primary
              type="button"
              id="btnSubmit"
              style={{ fontWeight: 'bold', color: Colors.GRAY[1], margin: 'auto', cursor: 'pointer', marginTop: '10px', fontSize: 13 }}
              onClick={() => {
                let e = paginationControls;
                e.currentPage++;
                setPaginationControls(e);

                fitinsur.setAuthToken(authContext.token);
                if (location.search) {
                  handleListState(e.currentPage, location.search)
                } else {
                  handleListState(e.currentPage)
                }
              }}>
              CARREGAR MAIS COTAÇÕES
            </Text>
          </ButtonContainer>
        ) : ''
        }
      </Layout>
    </>
  );
}
